"use client";

import { useEffect, useState } from "react";
import { PixelText } from "@/components/ui/pixel-text";
import { Button } from "@/components/ui/button";

// Palette (PIXEL_STYLE.md — earth + accent only).
const CREAM = "#f5ecd6";
const INK = "#1a1a1a";
const WALNUT = "#5c4a30";
const SAND = "#b89968";
const GOLD = "#c5a83a";

export function KeyboardHintsOverlay() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem("surggies_hints_seen");
    if (!seen) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem("surggies_hints_seen", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="absolute inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: "rgba(26, 26, 26, 0.6)" }}
    >
      <div
        className="w-[380px]"
        style={{
          backgroundColor: CREAM,
          border: `2px solid ${INK}`,
          boxShadow: `3px 3px 0 ${INK}`,
          imageRendering: "pixelated",
        }}
      >
        <div
          className="px-4 py-3"
          style={{ backgroundColor: SAND + "60", borderBottom: `2px solid ${INK}` }}
        >
          <PixelText as="div" glow="pink" size="sm" className="w-full">
            Controls
          </PixelText>
        </div>

        <div className="p-5 space-y-4">
          <div className="flex items-center gap-3">
            <HintKey label="↑" />
            <HintKey label="↓" />
            <HintKey label="←" />
            <HintKey label="→" />
            <span className="font-mono text-sm" style={{ color: WALNUT }}>
              Move around Miami Beach
            </span>
          </div>

          <div className="flex items-center gap-3">
            <HintKey label="E" accent={GOLD} />
            <span className="font-mono text-sm" style={{ color: WALNUT }}>
              Interact with buildings, NPCs, and Surggies
            </span>
          </div>

          <div className="flex items-center gap-3">
            <HintKey label="C" />
            <span className="font-mono text-sm" style={{ color: WALNUT }}>
              Chat with your team in the side panel
            </span>
          </div>

          <div className="flex items-center gap-3">
            <HintKey label="Z" />
            <span className="font-mono text-sm" style={{ color: WALNUT }}>
              Catch wild Surggies in the sand areas!
            </span>
          </div>
        </div>

        <div className="px-4 pb-4">
          <Button variant="default" className="w-full" onClick={handleDismiss}>
            Got it!
          </Button>
        </div>
      </div>
    </div>
  );
}

function HintKey({ label, accent = INK }: { label: string; accent?: string }) {
  return (
    <div
      className="w-8 h-8 flex items-center justify-center"
      style={{ backgroundColor: CREAM, border: `2px solid ${accent}` }}
    >
      <span className="font-mono text-xs font-bold" style={{ color: accent }}>
        {label}
      </span>
    </div>
  );
}